// Every localStorage key the new Bible page owns, in one place. Scattered string
// literals had already drifted into three naming styles, and a key nobody can
// find is a key nobody deletes — several outlived the features that wrote them.
//
// The reader owns /bible, so its keys use the permanent `bible` prefix. Values
// saved while it lived at /new-bible were carried over from the `bibleNext`
// names; that migration is done and those keys are gone.
//
// FAVORITE_TRANSLATIONS_KEY is NOT here on purpose — it is shared with the old
// /bible reader and must keep its own name (see lib/favorite_translations.ts).

const PREFIX = "bible";

/** Last workspace address, for restoring a bare /new-bible entry. */
export const LAST_PARAMS_KEY = `${PREFIX}Params`;

/** Reader settings: font, size, spacing, theme, Strong's numbers, draw-mode
 * color/stroke width. */
export const READER_SETTINGS_KEY = `${PREFIX}Settings`;

/** Column proportions, a fit to this device. */
export const PANE_WEIGHTS_KEY = `${PREFIX}PaneWeights`;

/** Which note each note column had open (slot → note id). */
export const NOTE_SLOTS_KEY = `${PREFIX}NoteSlots`;

/** Translations chosen for comparison, in card order. */
export const COMPARISON_TRANSLATIONS_KEY = `${PREFIX}CompareTranslations`;

/** The compared passage, so a reload reopens on it. */
export const COMPARISON_TARGET_KEY = `${PREFIX}CompareTarget`;

/** Recent search queries, newest first. */
export const SEARCH_HISTORY_KEY = `${PREFIX}SearchHistory`;

export type BibleStorageKey =
	| typeof LAST_PARAMS_KEY
	| typeof READER_SETTINGS_KEY
	| typeof PANE_WEIGHTS_KEY
	| typeof NOTE_SLOTS_KEY
	| typeof COMPARISON_TRANSLATIONS_KEY
	| typeof COMPARISON_TARGET_KEY
	| typeof SEARCH_HISTORY_KEY;
